import journeyBackground from "assets/demo/journeyBackground.jpeg"
import { type ResultOf } from "graphql-mock"
import { graphql } from "../../../graphql"
import { journeyCardFragment, mockJourneyCardData } from "../JourneyCard/gql"

// TODO
// This entire file will be refactored when I am done with Journey refactor.
export type Data = ResultOf<typeof query>["productCategory"]

export const journeyFragment = graphql(
  `
    fragment Journey on ProductCategory {
      id
      title
      description
      descriptionImageUrl
      backgroundImageUrl
      isLocked
      progress {
        isCertified
        certifiedCount
        certifiedMax
      }
      lockedBy(limit: 1) {
        nodes {
          title
        }
      }
      unlocked(limit: 1) {
        nodes {
          title
          backgroundImageUrl
        }
      }
      products(limit: 20) {
        nodes {
          ...JourneyCard
        }
      }
    }
  `,
  [journeyCardFragment]
)

export const query = graphql(
  `
    query SingleJourney($id: ID!) {
      productCategory(id: $id) {
        ...Journey
      }
    }
  `,
  [journeyFragment]
)

export const defaultJourney: Data = {
  id: "",
  title: null,
  isLocked: false,
  description: null,
  descriptionImageUrl: null,
  backgroundImageUrl: null,
  progress: {
    isCertified: false,
    certifiedCount: 0,
    certifiedMax: 0,
  },
  lockedBy: { nodes: [] },
  unlocked: { nodes: [] },
  products: { nodes: [] },
}

// This will be removed once I'm done.
export const mockJourneyData = {
  id: "1",
  title: "Onboarding week one",
  isLocked: false,
  description: "",
  descriptionImageUrl: null,
  backgroundImageUrl: journeyBackground,

  progress: {
    isCertified: false,
    certifiedCount: 73,
    certifiedMax: 100,
  },

  lockedBy: {
    nodes: [
      {
        title: "Onboarding week zero",
      },
    ],
  },

  unlocked: {
    nodes: [
      {
        title: "Onboarding week two",
        backgroundImageUrl: journeyBackground,
      },
    ],
  },

  products: {
    nodes: [
      mockJourneyCardData({
        progress: { certified: true, starsCount: 1, mandatory: true },
      }),
      mockJourneyCardData({
        progress: {
          certified: true,
          starsCount: 4,
          starsMax: 5,
          mandatory: true,
        },
        productType: "skill",
      }),
      mockJourneyCardData({
        progress: { certified: true, mandatory: true },
        productType: "activity",
      }),
      mockJourneyCardData({
        progress: { certified: false, mandatory: true },
        hasPlayedXapi: true,
        productType: "xapi",
      }),
      mockJourneyCardData({
        progress: { starsCount: 0, starsMax: 5, mandatory: true },
        productType: "skill",
      }),
      mockJourneyCardData({}),
      mockJourneyCardData({
        progress: { certified: true, starsCount: 1, mandatory: true },
      }),
      mockJourneyCardData({
        progress: {
          certified: true,
          starsCount: 4,
          starsMax: 5,
          mandatory: true,
        },
        productType: "skill",
      }),
      mockJourneyCardData({
        productType: "activity",
      }),
      mockJourneyCardData({
        progress: { certified: false, mandatory: true },
        hasPlayedXapi: true,
        productType: "xapi",
      }),
      mockJourneyCardData({
        progress: { starsCount: 0, starsMax: 5, mandatory: true },
        productType: "skill",
      }),
      mockJourneyCardData({}),
      mockJourneyCardData({
        progress: { certified: true, starsCount: 1, mandatory: true },
      }),
      mockJourneyCardData({
        progress: {
          certified: true,
          starsCount: 4,
          starsMax: 5,
          mandatory: true,
        },
        productType: "skill",
      }),
      mockJourneyCardData({
        productType: "activity",
      }),
      mockJourneyCardData({
        progress: { certified: false, mandatory: true },
        hasPlayedXapi: true,
        productType: "xapi",
      }),
      mockJourneyCardData({
        progress: { starsCount: 0, starsMax: 5, mandatory: true },
        productType: "skill",
      }),
      mockJourneyCardData({}),
    ],
  },
}
